import TextEditor from ".";
import React, { useRef, useState, useMemo } from "react";
import JoditEditor from "jodit-react";
import { Jodit } from "jodit/es2021/jodit.min.js";
import "jodit/es2021/jodit.min.css";

const RichEditor = ({ value = "", onChange }) => {
  const editor = useRef(null);

  const editorConfig = {
    buttons: [
      "bold",
      "italic",
      "underline",
      "|",
      "font",
      "fontsize",
      "brush",
      "paragraph",
      "|",
      "align",
      "lineHeight",
      "ul",
      "ol",
      "|",
      "indent",
      "outdent",
      "table",
      "link",
      "|",
      "hr",
      "eraser",
      "undo",
      "redo",
      "|",
      "fullsize",
      "print",
      "about"
    ],
    toolbarAdaptive: false,
    defaultMode: "1",
    enter: "P",
    language: "en",
    spellcheck: true,
    toolbarSticky: false,
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false
  };

  return (
    <JoditEditor
      ref={editor}
      value={value}
      config={editorConfig}
      tabIndex={1} // tabIndex of textarea
      onBlur={onChange}
      onChange={() => {}} // avoid React warning
    />
  );
};

export default RichEditor;
